import * as CryptoJS from 'crypto-js';
import env from './env';

const passPhrase = env('POS_PASSPHRASE') || '';

/**
 * Cookie keys are; _pos_tokid(token id) | _pos_usrid(user id) | _pos_sale (sales)
 * @param key
 * @param value
 */
const setToLocalStorage = (key: string, value: string) => {
  const cipheredValue = CryptoJS.AES.encrypt(value, passPhrase).toString();
  localStorage.setItem(key, cipheredValue);
};

export default setToLocalStorage;
